import { Component, OnInit, Inject } from '@angular/core';
import { Images } from '../../config/images-config';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as fromStore from '../../../cep/store/index';;
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-sameer-popup',
  templateUrl: './sameer-popup.component.html',
  styleUrls: ['./sameer-popup.component.scss']
})
export class SameerPopupComponent implements OnInit {

  elementType: 'url' | 'canvas' | 'img' = 'url';

  value: string = 'https://play.google.com/store/apps/details?id=com.dataapp&hl=en_IN';
  url: string = 'https://apps.apple.com/in/app/pcmc-smart-sarathi/id1495025693';
  images = Images;
  playStoreUrl = 'https://fxurl.co/rFshd';
  AppStoreUrl = 'https://fxurl.co/4IJJ123';
  selectedLanguage: string;

  /**
   * angular method for declaring packages in variables
   * 
   * which runs first in this particulat component
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SameerPopupComponent>,
    private store: Store<fromStore.CEPState>,) {
      
  }

  ngOnInit() {
    this.store.select(fromStore.getSelectedLanguage)
    .subscribe((language) => {
      this.selectedLanguage = language;
    });
  }

  /**
   * Created by Prajta P
   * For closing thr popup
   */
  closeDialog() {
    this.dialogRef.close()
  }

  getHeaderText(){
    return this.selectedLanguage === 'en' ? 'Get the Sameer App Link by Clicking Icons Below' : 'खालील चिन्हांवर क्लिक करून समीर ॲप लिंक मिळवा'
  } 

}
